import NewDash from "../layouts/NewDash.jsx";


var clinicDashBoardRoutes = [

    {path: "/newdash", name: "New Dash", component: NewDash},
];

export default clinicDashBoardRoutes;



// WEBPACK FOOTER //
// ./src/routes/clinicDasboard.jsx